// Alert de shadcn, copiada al repo como la fila de aviso de identidad
// (components/operacion/FilaAlerta): barra de severidad de 3px a la
// izquierda, borde hairline y fondo apenas velado. Acero para informacion,
// ambar para aviso, critico para error. El color no es el unico portador del
// mensaje: el texto dice que pasa, y el `role` hace que un lector de pantalla
// lo anuncie.
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./cn.js";

const estilos = cva(
  "relative m-0 rounded-md border border-linea border-l-[3px] bg-velo px-3.5 py-2.5 text-sm leading-normal text-texto-2",
  {
    variants: {
      variant: {
        info: "border-l-acero-claro",
        aviso: "border-l-ambar",
        error: "border-l-critico text-critico-texto",
      },
    },
    defaultVariants: { variant: "info" },
  },
);

export interface AlertProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof estilos> {}

export function Alert({ className, variant, ...props }: AlertProps): React.JSX.Element {
  return (
    <p
      // Un error se anuncia al toque; un aviso o una nota esperan su turno.
      role={variant === "error" ? "alert" : "status"}
      className={cn(estilos({ variant }), className)}
      {...props}
    />
  );
}
